import Config from '../Config';
import Util from '../Util';
import ProfileImg from '../ProfileImg';
import GameInfo from '../GameInfo';
import Site from '../Site';
import User from '../User';
import Template from 'js-template-string';
import DateFormat from 'date-format-simple';

const dateFormat = new DateFormat( Config.now, {
  'a_few_seconds_ago': Config.L10N.a_few_seconds_ago,
  'seconds_ago': Config.L10N.seconds_ago,
  'a_minute_ago': Config.L10N.a_minute_ago,
  'minutes_ago': Config.L10N.minutes_ago,
  'an_hour_ago': Config.L10N.an_hour_ago,
  'hours_ago': Config.L10N.hours_ago,
  'a_day_ago': Config.L10N.a_day_ago,
  'days_ago': Config.L10N.days_ago,
  'a_month_ago': Config.L10N.a_month_ago,
  'months_ago': Config.L10N.months_ago,
  'a_year_ago': Config.L10N.a_year_ago,
  'years_ago': Config.L10N.years_ago,
}, true );

const setWriterInfo = ( url = '', gameCharName = '', info = '' ) => {
  return ( Config.isMyProfile ) ?
  `${ Util.setWrapLink( url, gameCharName )}${ info }` : gameCharName + info;
};

const setWriterImage = ( url = '', profileImg = '' ) => {
  const image = Util.setWrapImage( profileImg );
  return ( Config.isMyProfile ) ?
  Util.setWrapLink( url, image ) : image;
};

const numberWithCommas = (x) => {
    let parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

const _Template = {
  listTop: () => {
    const _top = Template.render({
      data: '',
      template: ( data ) => `
        <div class="board-top-utils">
        <div id="wrapSearch" class="wrap-search"></div>
        <div class="board-btngroup">
          ${ ( (Config.isCardView && Config.isThumbView) || (Config.isListView && Config.isCardView) )?
          `<div class="wrap-btn-type">
            <button class="btn-type-selected"><i class="fe-icon-"></i></button>
            <span class="btn-type-list">
            ${( Config.isListView )  ? `<button class="co-btn btn-list"><i class="fe-icon-list"></i></button>` : ``}
            ${( Config.isThumbView ) ? `<button class="co-btn btn-list"><i class="fe-icon-list"></i></button>` : ``}
            ${( Config.isCardView ) ? `<button class="co-btn btn-cards"><i class="fe-icon-cards"></i></button>` : ``}
            </span>
          </div>`: ``}
          <span class="list-count-area"></span>
          <button class="co-btn btn-reload"><i class="fe-icon-reload"></i></button>
          ${( Config.isWrite && Config.board !== 'all' ) ? `<button class="co-btn co-btn-round btn-write"><i class="fe-icon-write_w"></i><span>${Config.L10N.btn_write}</span></button>` : ``}
        </div>
        </div>`,
      });

    return _top;
  },

  noticeList: ( _data, _categoryId = '' ) => {
    return Template.iterate({
      data: _data,
      template: ( data ) => {
        const urlPath = data.notice.category.urlPath;
        const writer = data.article.writer;
        const loginUser = writer.loginUser;
        const gameUser = writer.gameUser;
        const characterName = gameUser.gameCharacterName || loginUser.name;
        let serverName = Config.serverName[ gameUser.gameServerId || '' ] || '';
        let param = `&isNotice=1`;
        let _postDate = data.notice.publishDate;

        //It's works.. If current list has categoryId
        if ( _categoryId && urlPath.indexOf( 'categoryId' ) !== -1 ) {
          param = `${param}&categoryId=${_categoryId}`;
        }

        let _url = ( Config.useAPIListUrl && data.article.url ) ?
          `${data.article.url}${param}` :
          `${Config.viewPage}?articleId=${data.article.articleId}${param}`;

        if ( serverName ) {
          serverName = `<span class="server">${ serverName }</span>`;
        }

        if ( Config.prefixPath ) {
          _url = `${Config.prefixPath}/board/${Config.board}/${Config.viewPage}?articleId=${data.article.articleId}${param}`;
        }

        if ( !isNaN( _postDate ) ) {
            _postDate = new Date( _postDate );
            _postDate = Util.toISOString( _postDate );
        }

        return `<div class="board-notice-item">
        <a href="${_url}">${(data.notice.label) ?`<span class="category">${data.notice.label}</span>`:``}${data.article.title}</a>
        ${ (Util.diffDate(dateFormat.toGMTDate(_postDate), dateFormat.getNow()) <= 3600000 * 24) ? `<i class="fe-icon-new" data-diff=""></i>` : ``}
        <div class="info">
        ${ ( data.article.writer.emoticonUrl)?
            `<span class="writer"><img src="${data.article.writer.emoticonUrl}" alt=""/></span>`:
            `<span class="writer user">${characterName}${serverName}</span>` }
        </div>
        </div>`;
      },
    });
  },

  getNew: ( _date, markup = `<i class="fe-icon-new" data-diff=""></i>` ) => {
    if ( !_date ) {
      return '';
    }

    return ( Util.diffDate( dateFormat.toGMTDate( _date ), dateFormat.getNow() ) <= 3600000 * 24 ) ? markup : ``;
  },

  getDateFormat: ( _date ) => {
    return dateFormat.printUntil( _date, 'day', true );
  },

  thumbList: ( _data, _id, param = '' ) => {
    dateFormat.setDateFormat('YY.MM.DD.');
    const _list = Template.iterate({
      data: _data.articleList,
      template: ( articleList ) => {
        const usr = User.setUser( articleList, param );
        const raceName = Site.race( articleList );

        return `<li class="board-items" data-articleid="${usr.articleId}" data-master="${ Site.serverMaster( articleList ) }">
        <div class="thumb">
        ${( usr.thumbnailUrl ) ? `<a href="${ usr._url }"><img src="${ usr.thumbnailUrl }" alt=""></a>` : ''}
        </div>
        <div class="title">
        <a href="${ usr._url }">${ usr.title }</a>
        ${( usr.hasThumbnail ) ? `<i class="fe-icon-picture"></i>` : `` }
        ${( usr.hasVote ) ? `<i class="fe-icon-vote"></i>` : `` }
        <div class="count" data-articleid="${ usr.articleId }">
        <span class="count-like" data-count="${ ( usr.goodCount >= 0 ) ? usr.goodCount : 0 }"><i class="fe-icon-like"></i><em>${ ( usr.goodCount >= 0 ) ? numberWithCommas(usr.goodCount) : 0 }</em></span>
        <span class="count-comment" data-count="${ usr.commentCount }"><i class="fe-icon-comment"  data-count="${ usr.commentCount }"></i><em>${ numberWithCommas(usr.commentCount) }</em></span>
        </div>
        ${ (Util.diffDate(dateFormat.toGMTDate(usr._postDate), dateFormat.getNow()) <= 3600000 * 24) ? `<i class="fe-icon-new" data-diff=""></i>` : ``}
        </div>
        <div class="info">
            ${( usr._adminUser && usr._writer.emoticonUrl) ?
            `<span class="writer writer-admin"><img src="${ usr._writer.emoticonUrl }" alt=""/></span>` :
            `<span class="writer">${usr.writerInfo + usr._server + raceName}</span>` }
            <span class="date">${ dateFormat.printUntil( usr._postDate, 'day', true ) }</span>
            <span class="hit"><em class="txt">${Config.L10N.hit}</em>${ numberWithCommas(usr.hitCount) }</span>
            <span class="like" data-count="${( usr.goodCount >= 0 ) ? usr.goodCount : 0}">${Config.L10N.recommend}<em>${( usr.goodCount >= 0 ) ? numberWithCommas(usr.goodCount) : 0}</em></span>
        </div>
        <div class="comment">
            <a href="${ usr._url}#${Config.COMMENT_ANCHOR_NAME}" data-count="${usr.commentCount}">
                <span>
                    <em class="number"> ${(usr.commentCount < 999) ? usr.commentCount :`999+` }</em>
                    <em class="txt">${Config.L10N.comment}</em>
                </span>
            </a>
        </div>
        </li>`;
      },
    });

    return Template.render({
      data: _list,
      template: ( list ) => `<ul class="${ _id } board-list-thumb">${ list }</ul>`,
    });
  },

  cardList: ( _data, _id, param = '' ) => {
    dateFormat.setDateFormat('YY.MM.DD.');
    const _list = Template.iterate({
      data: _data.articleList,
      template: ( articleList ) => {
        const usr = User.setUser( articleList, param );
        const runningTime = Site.runningTime( articleList );

        usr.thumbnailUrl = GameInfo.thumbnailUrl( usr.thumbnailUrl );

        return `<li class="board-items" data-articleid="${usr.articleId}"
          data-is-summary="${( usr.summary.length > 0 ) ? true : false}"
          data-master="${ Site.serverMaster( articleList ) }">
          ${(usr.thumbnailUrl) ?
            `<div class="board-items-thumb"><a href="${usr._url}"><img src="${usr.thumbnailUrl}" alt="">${runningTime}</a></div>` : ``}
             <div class="board-items-contents">
          <div class="title">
          ${( Config.isShowListCategory ) ? `<span class="category">${ usr.categoryName }</span>` : ``}
          <a href="${ usr._url }">
          ${ usr.title }
          ${( usr.hasVote ) ? `<i class="fe-icon-vote"></i>` : `` }
          ${ ( Util.diffDate( dateFormat.toGMTDate( usr._postDate ), dateFormat.getNow() ) <= 3600000 * 24 ) ? `<i class="fe-icon-new" data-diff=""></i>` : ``}
          </a>
          </div>
          <div class="desc ${( usr.thumbnailUrl ) ? '' : 'desc-overflow'}">
            <a href="${ usr._url }">
            ${ ( usr.summary ) ? usr.summary.replace( /\n/g, `<br/>`) : '' }
            ${ ( usr.searchSummary ) ? usr.searchSummary.replace( /\n/g, `<br/>`) : '' }
            </a>
          </div>
          ${(usr._adminUser && usr._writer.emoticonUrl) ?
            `<div class="writer writer-admin"><img src="${usr._writer.emoticonUrl}" alt=""/></div>`:
            `<div class="writer">${usr.writerInfo + usr._server}</div>`}
          </div>
          <div class="board-items-footer">
          <div class="info">
            ${(usr._adminUser && usr._writer.emoticonUrl) ?
              `<span class="writer writer-admin"><img src="${usr._writer.emoticonUrl}" alt=""/></span>`:
              `<span class="writer">${usr.writerInfo}</span>`
            }
              <span class="date">${dateFormat.printUntil( usr._postDate, 'day', true ) || Config.L10N.a_few_seconds_ago}</span>
              <span class="hit-count" data-count="${( usr.hitCount >= 0 ) ? usr.hitCount : 0}">
                <span class="txt">${Config.L10N.hit} </span><em>${( usr.hitCount >= 0 ) ? numberWithCommas(usr.hitCount) : 0}</em>
              </span>
              <span class="like" data-count="${( usr.goodCount >= 0 ) ? usr.goodCount : 0}">${Config.L10N.recommend}<em>${( usr.goodCount >= 0 ) ? numberWithCommas(usr.goodCount) : 0}</em></span>
            </div>
          <div class="count" data-articleid="${usr.articleId}" >
          ${ ( Config.isListShare ) ? `<button class="co-btn co-btn-share" data-location="${ usr._url }" data-title="${ usr.summary }"><i class="fe-icon-share"></i></button>` : ``}
          <span class="count-like" data-count="${( usr.goodCount >= 0 ) ? usr.goodCount : 0}">
            <i class="fe-icon-like"></i><em>${( usr.goodCount >= 0 ) ? numberWithCommas(usr.goodCount) : 0}</em>
          </span>
          <span class="count-comment" data-count="${usr.commentCount}">
            <i class="fe-icon-comment" ></i><em>${numberWithCommas(usr.commentCount)}</em>
          </span>
          </div>
          </div>
          </div>
          </li>`;
        },
    });

    return Template.render({
      data: _list,
      template: ( list ) => `<ul class="${_id} board-list-card">${list}</ul>`,
    });
  },

  list: ( _data, _id, param = '' ) => {
    dateFormat.setDateFormat('YY.MM.DD.');
    const _list = Template.iterate({
      data: _data.articleList,
      template: ( articleList ) => {
        const usr = User.setUser( articleList, param );
        const raceName = Site.race( articleList );

        //bnsAPP app characterName
        if ( Config.isBnsApp &&  usr._gameUser && usr._gameUser.gameCharacterName ) {
          const inlineStyle = `style="text-decoration:none;color:#8c919a;"`;
          writerInfo = `<a href="${Config.app.popup}http://${Util.net( '.' )}a.bns.plaync.com/world/character/character?cn=${usr._gameUser.gameCharacterName}" ${inlineStyle}>
          ${usr._gameUser.gameCharacterName}</a>`;
        }

        return `<li class="board-items" data-articleid="${usr.articleId}"
        data-master="${ Site.serverMaster( articleList ) }">
        <div class="title">
        ${( Config.isShowListCategory ) ? `<span class="category">${usr.categoryName}</span>` : ``}
        <a href="${ usr._url }">
        ${ usr.title }
        </a>
        ${( usr.hasThumbnail ) ? `<i class="fe-icon-picture"></i>` : `` }
        ${( usr.hasVote ) ? `<i class="fe-icon-vote"></i>` : `` }
        <div class="count" data-articleid="${usr.articleId}">
          ${ ( Config.isListShare ) ? `<button class="co-btn co-btn-share" data-location="${ usr._url }" data-title="${ usr.summary }"><i class="fe-icon-share"></i></button>` : ``}
          <span class="count-like" data-count="${( usr.goodCount >= 0 ) ? usr.goodCount : 0}"><i class="fe-icon-like"></i><em>${( usr.goodCount >= 0 ) ? numberWithCommas(usr.goodCount) : 0}</em></span>
          <span class="count-comment" data-count="${usr.commentCount}"><i class="fe-icon-comment"></i><em>${numberWithCommas(usr.commentCount)}</em></span>
        </div>
        ${ (Util.diffDate(dateFormat.toGMTDate(usr._postDate), dateFormat.getNow()) <= 3600000 * 24) ? `<i class="fe-icon-new" data-diff=""></i>` : ``}
        </div>
        <div class="info">
            ${( usr._adminUser && usr._writer.emoticonUrl) ?
            `<span class="writer writer-admin"><img src="${usr._writer.emoticonUrl}" alt=""/></span>`:
            `<span class="writer">${usr.writerInfo + usr._server + raceName}</span>` }
          <span class="date">${dateFormat.printUntil( usr._postDate, 'day', true ) || Config.L10N.a_few_seconds_ago}</span>
          <span class="hit"><em class="txt">${Config.L10N.hit}</em>${numberWithCommas(usr.hitCount)}</span>
          <span class="like" data-count="${( usr.goodCount >= 0 ) ? usr.goodCount : 0}">${Config.L10N.recommend}<em>${( usr.goodCount >= 0 ) ? numberWithCommas(usr.goodCount) : 0}</em></span>
          ${( ( Config.isArticleDelete && usr.isMyArticle ) || Config.isBookmarkDelete ) ?
          `<button class="co-btn delete" data-articleid="${usr.articleId}">${Config.L10N.btn_delete}</button>` : ``}
        </div>
        <div class="comment">
            <a href="${ usr._url}#${Config.COMMENT_ANCHOR_NAME}" data-count="${usr.commentCount}">
                <span>
                    <em class="number">${(usr.commentCount < 999)? usr.commentCount:`999+` }</em>
                    <em class="txt">${Config.L10N.comment}</em>
                </span>
            </a>
        </div>
        </li>`;
      },
    });

    return Template.render({
      data: _list,
      template: ( list ) => `<ul class="${_id} board-list-default">${list}</ul>`,
    });
  },

    searchList: ( _data, _id, param = '' ) => {
      dateFormat.setDateFormat('YY.MM.DD.');
        const _list = Template.iterate({
            data: _data.articleList,
            template: ( articleList ) => {
            const usr = User.setUser( articleList, param );
        const raceName = Site.race( articleList );

        return `<li class="board-items ${(usr.hasThumbnail) ?`board-items-thumb`:``}" data-articleid="${usr.articleId}"
            data-master="${ Site.serverMaster( articleList ) }">
            <div class="search-content">
                ${(usr.hasThumbnail) ? `<div class="thumb"><img src="${ usr.thumbnailUrl }" alt=""></div>` : `` }
                <div class="title">
                    ${( Config.isShowListCategory ) ? `<span class="category">${usr.categoryName}</span>` : ``}
                    <a href="${ usr._url }">${ usr.title }</a>
                    ${( usr.hasVote ) ? `<i class="fe-icon-vote"></i>` : `` }
                </div>
                ${(usr.searchSummary) ? `<div class="desc"><a href="${ usr._url }">${ usr.searchSummary }</a></div>` : `` }
                </div>
              <div class="search-info">
                <span class="writer">${( usr._adminUser && usr._writer.emoticonUrl) ? `<img src="${usr._writer.emoticonUrl}" alt=""/>` : usr.writerInfo + usr._server + raceName}</span>
                <span class="date">${dateFormat.printUntil( usr._postDate, 'day', true ) || Config.L10N.a_few_seconds_ago}</span>
                <span class="hit"><em class="txt">${Config.L10N.hit}</em>${numberWithCommas(usr.hitCount)}</span>
                <span class="count-like" data-count="${( usr.goodCount >= 0 ) ? usr.goodCount : 0}"><i class="fe-icon-like"></i><span class="text">${Config.L10N.recommend}</span><em>${( usr.goodCount >= 0 ) ? numberWithCommas(usr.goodCount) : 0}</em></span>
                <span class="count-comment" data-count="${usr.commentCount}"><i class="fe-icon-comment"></i><em>${numberWithCommas(usr.commentCount)}</em></span>
              </div>
            </li>`;
        },
    });

    return Template.render({
            data: _list,
            template: ( list ) => `<ul class="${_id} board-list-search">${list}</ul>`,
    })
  },

  listShare: () => {
    return `<div id="ncShare" class="nc-share"></div>`;
  },

  prevNext: ( _data ) => {
    let _next = _data.nextArticle || ``;
    let _prev = _data.previousArticle || ``;
    const _tmpNext = _next;

    if ( Config.isReversePrevNext ) {
      _next = _prev;
      _prev = _tmpNext;
    }

    return Template.render({
      data: { _next: _next, _prev: _prev },
      template: ( _v ) => `
        <div class="board-nav">
        ${ ( _v._prev && _v._prev.articleId ) ?
        `<p class="prev">
          <span>${Config.L10N.prev_article}</span>
          <a href="${Config.viewPage}?articleId=${_v._prev.articleId}&categoryId=${_v._prev.category.categoryId}">
            ${_v._prev.title}
          </a>
        </p>` : ''}

        ${ ( _v._next && _v._next.articleId ) ?
        `<p class="next">
          <span>${Config.L10N.next_article}</span>
          <a href="${Config.viewPage}?articleId=${_v._next.articleId}&categoryId=${_v._next.category.categoryId}">
            ${_v._next.title}
          </a>
          </p>` : ''}
        </div>`,
    });
  },

  comment: ( _content ) => {
    return `<section class="wrap-comment ncCommentCommonWrap">${_content}</section>`;
  },

  setCommentUploadFrame: ( frameSrc = `${window._path || '/'}html/commentUpload.html`, content ) => {
    return `<iframe src="${frameSrc}" class="comment-upload comment-frame${content}" frameborder="0" scrolling="no" width="30" height="20"></iframe>`;
  },

  setCommentEmoticon: () => {
    return `<span class="co-btn btn-emoticon"><i class="editor-icon-emoticon"></i></span>`;
  },

  commentWrite: ( content, placeHolder = '', isUpdate = false ) => {
    const isActive = ( Config.isLogin() ) ? 'is-active' : '';

    return `<div class="comment-form comment-form-${content} ${isActive}">
    <i class="fe-icon-reply"></i>
    <div class="comment-form-textarea">
    <textarea class="${content}" name="content" placeholder="${placeHolder || Config.L10N.comment_placeholder_logout}" ></textarea>
    </div>
    <div class="comment-toolbar">
    <div class="left">
    ${ ( !isUpdate && Config.isCommentEmoticon ) ? `${ _Template.setCommentEmoticon() }` : `` }
    ${ ( !isUpdate && Config.isCommentUpload ) ? `${ _Template.setCommentUploadFrame( Config.commentUploadFrame, content ) }` : `` }
    </div>
    <div class="right">
    <span class="count-word"><em>0</em>/${Config.commentTextMaxCount}</span>
    <button type="button" class="co-btn btn-confirm btn-${content}">${( !isUpdate ) ? Config.L10N.btn_register : Config.L10N.btn_modify}</button>
    </div>
    </div>
    </div>`;
  },

  commentRemove: () => {
    return `<div class="comment-article-delete">
    <div class="comment-info"></div>
    <div class="comment-contents">${Config.L10N.comment_list_delete}</div>
    <div class="comment-utils"></div>
    </div>`;
  },

  commentList: ( _data, timeMsg = '' ) => {
    if ( !_data.commentList ) {
      return '';
    }

    if ( GameInfo.isMine() ) {
      Config.isOwnerOfArticle = true;
    }

    return Template.iterate({
      data: _data.commentList,
      template: ( _v ) => {
        const _writer = _v.writer;
        const _adminUser = Util.setDefaultByEmptyString( _writer.adminUser );
        const _gameUser = Util.setDefaultByEmptyString( _writer.gameUser );
        const _loginUser = Util.setDefaultByEmptyString( _writer.loginUser );
        const _gameCharacterId = Util.setDefaultByEmptyString( _gameUser.gameCharacterId );
        const _gameCharName = Util.setDefaultByEmptyString( _gameUser.gameCharacterName );
        const _gameServerId = Util.setDefaultByEmptyString( _gameUser.gameServerId );
        const _loginName = Util.setDefaultByEmptyString( _loginUser.name );

        //my writing article
        const _isNewWrited = _v.isNewWrited;
        const emoticonUrl = Util.setDefaultByEmptyString( _v.writer.emoticonUrl );
        const characterUrl = Site.characterUrl( _v );
        const sandboxUrl = Site.sandboxUrl( _v );
        const raceName = Site.race( _v );

        let _contents = _v.contents;
        let _server = '';
        let url = '';
        let writerInfo;
        let writerImg;
        let _contentType = 'text';
        let _postDate = _v.postDate;
        let profileImg = Util.setDefaultByEmptyString( _gameUser.profileImage );
        let isMyArticle = Util.and( Config.guid, ( Config.guid === _loginUser.uid ) );

        if ( Util.and( !_loginUser.uid, _gameUser ) ) {
          isMyArticle = GameInfo.isEqualGameUser( _gameCharName, _gameServerId );
        }

        _contents = Util.replaceImage( _contents );

        //If contents type is Image
        if ( _contents.indexOf( '<img src' ) !== -1 ) {
          _contentType = 'image';
        }

        if ( !isNaN( _postDate ) ) {
          _postDate = new Date( _postDate );
          _postDate = Util.toISOString( _postDate );
        }

        //checked server exists
        if ( Util.and( Config.isUserInfoWithServer, Config.serverName, _gameServerId, Config.serverName[ _gameServerId ] ) ) {
          _server = `<span class="server">${ Util.or( Config.serverName[ _gameServerId ], '&nbsp;' ) }</span>`;
        }

        //Remove reply, if isNoReply option is true
        if ( Config.isNoReply && _v.depth && _v.depth.toString() === '1' ) {
          return '';
        }

        //It works, if ncAccount is false and character is true
        if ( Util.and( Util.or( _gameUser.gameUserUid, _gameCharacterId ), _gameCharName, !Config.isNcAccount ) ) {
          url = GameInfo.gameUserProfile( _gameUser.gameUserUid, _loginUser.uid, Config.guid, _gameCharName, _gameServerId, _gameUser.gameCharacterId );
          profileImg = profileImg || ProfileImg.getCharacter( _gameUser.gameUserUid, _gameServerId, _gameUser.gameCharacterId );
          writerInfo = setWriterInfo( url, _gameCharName, _server + raceName );
          writerImg = setWriterImage( url, profileImg );

        //writing article by me
        } else if ( Util.and( !Config.isNcAccount, _gameCharName, _server && _isNewWrited ) ) {
          url = GameInfo.userProfile( _loginUser.uid, Config.guid );
          writerInfo = setWriterInfo( url, _gameCharName, _server + raceName );
          writerImg = setWriterImage( url, profileImg );

        } else {
          //ncAccount
          url = GameInfo.userProfile( _loginUser.uid, Config.guid );
          profileImg = profileImg || ProfileImg.getProfile( _loginUser.uid );
          writerInfo = setWriterInfo( url, Util.or( _loginName, _gameCharName ) );
          writerImg = setWriterImage( url, profileImg );
        }

        //It works, If bnsApp is true
        if ( Util.and( Config.isBnsApp, _gameCharName ) ) {
          profileImg = ProfileImg.getCharacter( _gameUser.gameUserUid, _gameServerId, _gameUser.gameCharacterId );
          writerInfo = ( _loginUser.name ) +
            Util.setWrapLink( `${ Config.app.popup }http://${ Util.net( '.' ) }a.bns.plaync.com/world/character/character?cn=${ _gameCharName }`, `[${ _gameCharName }]` );
          writerImg = ``;
        } else if ( Config.isBnsApp ) {
          writerInfo = `${ Util.or( _loginUser.name, _gameCharName ) }`;
          writerImg = ``;
        }

        //@TODO It works, If this site is bns
        if ( Util.and( sandboxUrl, characterUrl, _loginName, _gameCharName ) ) {
          writerInfo = `${ Util.setWrapLink( sandboxUrl, _loginName ) }<span class="">[${ Util.setWrapLink( characterUrl, _gameCharName ) }]</span>`;
        }

        if ( emoticonUrl && _adminUser ) {
          writerInfo = Util.setWrapImage( emoticonUrl );
        }

        if ( emoticonUrl && Config.board === 'devnote' ) {
          writerInfo = `<img src="${ emoticonUrl }" alt="" style="max-height:19px;"/>`;
        }

        //lineage
        if ( GameInfo.getSite() === 'lineage' ) {
          profileImg = Config.defaultCommentProfileImage;
          profileImg = Site.profileImg( _v, profileImg );
          writerImg = ( Config.isMyProfile ) ?
            Util.setWrapLink( url, Util.setWrapImage( profileImg ) ) :
            Util.setWrapImage( profileImg );
        }

        let commentStyle = '';
        let commentReplyStyle = '';
        let commentReplyButtonStyle = '';
        let commentThumb = `<span class="thumb">

        ${( _adminUser ) ?
          `${ Util.setWrapImage( Config.adminCommentImg ) }` :
          `${ writerImg }`
        }</span>`;

        if ( Config._isHideCommentProfile ) {
          commentStyle = `style="padding-left:0;"`;
          commentReplyStyle = `style="padding-left:26px;"`;
          commentReplyButtonStyle = `style="top:20px;left:-26px;"`;
          commentThumb = '';
        }

        // Todo 댓글 접기/펼치기 Template
        // let commentArticleMore = `<div class="comment-article-more">
        //     <button class="btn btn-article-more">이전 덧글 보기 || 이전 댓글 접기</button>
        // </div>`
        // `<div class="comment-article"></div>
        // ${commentArticleMore}
        // <div class="comment-article-reply"></div>`

        return `<div class=${( _v.depth && _v.depth.toString() === '1' ) ?
        `"comment-article-reply" ${commentReplyStyle} ` :
        ( _v.statusCode && _v.statusCode.toString() === 'NORMAL' ) ?
        `"comment-article" ${commentStyle} ` :
        `"comment-article-delete" ${commentStyle} `
        }
        data-commentid="${_v.commentId}">
        <div class="comment-info">
        <i class="fe-icon-reply" ${commentReplyButtonStyle}></i>
        ${commentThumb}
        <span class="writer">${writerInfo}</span>

        ${ ( Config.isBnsApp ) ?
        `<span class="date">${ Util.or( timeMsg, dateFormat._format( new Date( _v.postDate ) ) ) }</span>` :
        `<span class="date">${ Util.or( timeMsg, dateFormat.printUntil(  _postDate, 'day', true ) ) }</span>`
        }

        ${ ( Util.and( isMyArticle, Config.isCommentUpdate, _contentType === 'text' ) ) ?
        `<button class="co-btn btn-modify"
        data-commentuser="${ Util.or( _gameCharName, _loginName ) }"
        data-commentid="${_v.commentId}" data-uid="${_loginUser.uid}">
        ${Config.L10N.btn_modify}</button>
        <button class="co-btn btn-cancel"
        data-commentuser="${ Util.or( _gameCharName, _loginName ) }"
        data-commentid="${_v.commentId}" data-uid="${_loginUser.uid}" style="display:none;">
        ${Config.L10N.btn_cancel}</button>` : ``}

        ${ ( isMyArticle || ( Config.allowOwnerToDeleteComment && Config.isOwnerOfArticle ) ) ?
        `<button class="co-btn btn-delete"
        data-commentuser="${ Util.or( _gameCharName, _loginUser.name ) }"
        data-commentid="${_v.commentId}" data-uid="${_loginUser.uid}">
        ${Config.L10N.btn_delete}</button>` : ``}

        ${ ( Util.and( !_adminUser, !isMyArticle ) ) ?
        `<button class="co-btn btn-declare"
        data-commentuser="${ Util.or( _gameCharName, _loginUser.name ) }"
        data-commentid="${_v.commentId}" data-uid="${_loginUser.uid}">
        ${Config.L10N.more_report}</button>` : ``}
        </div>
        <div class="comment-contents">
        ${ ( _v.statusCode === 'DELETE_USER' || _v.statusCode === 'DELETE_ADMIN' ) ?
        `${Config.L10N.comment_list_delete}` :  Util.escape( _contents ) }
        </div>
        <div class="comment-utils">
        <button data-commentid="${_v.commentId}" class="co-btn co-btn-like">
        <i class="fe-icon-like"></i>
        <em class="text">${( _v.goodCount >= 0 ) ? _v.goodCount : 0}</em>
        </button>

        ${ ( Config.isNoReply ) ? `` :
        `<button class="co-btn co-btn-comments" data-commentid="${_v.commentId}">
        <i class="fe-icon-comments"></i>
        <em class="text">${_v.replyCount}</em>
        </button>`}
        </div>
        </div>`;
      },
    });
  },

  loader: ( id ) => {
    //@TODO Template
    return `<div class="nc-community-loader"><div class="loader-circle"></div></div>`;
  },

  communityLevelName: ( name ) => {
    return `<span class="community-level-name">${ name }</span>`;
  },

  viewSignature: ( _data ) => {
    const raceName = Site.race( _data.article );
    const _userInfo =  Site.userInfo( _data.article );

    return Template.render({
      data: _data,
      template: ( _v, _writer = _data.article.writer ) => {
        const _loginUser = _writer.loginUser;
        const _gameUser = _writer.gameUser;
        const _url = GameInfo.userProfile( _loginUser.uid, Config.guid, _gameUser.gameCharacterName, _gameUser.gameServerId ) || '#';
        const _communityLevelName = _v.communityLevelName || '';
        let _profileImg = '';
        let _userProfile = '';
        let _userName = _writer.loginUser.name;
        let communityLevelName = '';

        if ( _writer.loginUser.uid ) {
          _profileImg = ProfileImg.getProfile( _writer.loginUser.uid );
          _userProfile = `<img src="${_profileImg}" alt="">`;
        }

        if ( Config.isMyProfile ) {
          _userProfile = ( _profileImg ) ? `<a href="${_url}"><img src="${_profileImg}" alt=""></a>` : ``;
          _userName = `<a href="${_url}">${ _loginUser.name || _gameUser.gameCharacterName }</a>`;
        }

        if ( _communityLevelName && _communityLevelName !== '-' ) {
          communityLevelName = _Template.communityLevelName( _communityLevelName );
        }

        return `<div class="view-signature">
        <div class="thumb">${_userProfile}</div>
        <div class="writer">
        ${communityLevelName}
        ${_userName}
        </div>
        ${( _gameUser.gameCharacterName ) ?
        `<div class="info">
        ${ ( _gameUser.gameCharacterName ) ? `<span class="jon">${_gameUser.gameCharacterName}</span>` : ``}
        ${ ( _userInfo.server ) ? `<span class="servername">${_userInfo.server }</span>` : ``}
        ${ ( _userInfo.guild ) ? `<span class="clan">${ _userInfo.guild }</span>` : ``}
        ${ raceName }
        </div>` : ``}
        </div>`;
      },
    });
  },

  viewSignatureApp: ( _data ) => {
    const inlineStyle = `style="text-decoration:none;color:#8c919a;"`;
    const _userInfo =  Site.userInfo( _data.article );

    return Template.render({
      data: _data,
      template: ( _v, _writer = _data.article.writer ) => `
        <div class="view-signature">
        <div class="thumb"><img src="${ProfileImg.getProfile(_writer.loginUser.uid)}" alt=""></div>
          <div class="writer">
            <a href="${Config.app.popup}http://${Util.net( '.' )}sandbox.plaync.com/${_writer.loginUser.uid}" ${inlineStyle}>
            ${_writer.loginUser.name}
            </a>
          </div>
        ${( _writer.gameUser.gameCharacterName ) ?
        `<div class="info">
          ${ ( _writer.gameUser.gameCharacterName ) ? `<span class="jon">
          <a href="${Config.app.popup}http://${Util.net( '.' )}a.bns.plaync.com/world/character/character?cn=${_writer.gameUser.gameCharacterName}" ${inlineStyle}>
          ${_writer.gameUser.gameCharacterName}
          </a>
          </span>` : ``}
        </div>` : ``}
        </div>`,
    });
  },

  view: ( _data, isNotice ) => {
    if ( !Config.isLike ) {
      isNotice = true;
    }

    return Template.render({
      data: _data,
      template: ( _v, _article = _v.article ) => {
        const _writer = _article.writer;
        const _adminUser = _writer.adminUser;
        const _gameUser = _writer.gameUser;
        const _loginUser = _writer.loginUser;
        const _communityLevelName = _v.communityLevelName;
        const isMobile = jQuery( 'body' ).hasClass( 'mobile' );
        const isApp = jQuery( 'body' ).hasClass( 'app' );
        const raceName = Site.race( _article );
        let _server = '';
        let userProfile = '';
        let _contents = _article.contents;
        let communityLevelName = '';
        let isMyArticle = Util.and( Config.guid, ( Config.guid === _loginUser.uid ) );

        if ( Util.and( !_loginUser.uid, _gameUser ) ) {
          //myArticle check
          isMyArticle = GameInfo.isEqualGameUser( _gameUser.gameCharacterName, _gameUser.gameServerId );
        }

        if ( GameInfo.isMine() ) {
          Config.isOwnerOfArticle = true;
        }

        if ( Util.and( !isNotice, !Config.isAdmin, !isApp, Config.useMobileImage, !Config.isBnsApp, isMobile, Config.board !== 'cartoon' ) ) {
          const preset = ( Util.or( GameInfo.isMobileSite(), GameInfo.getSite() === 'lineage' ) ) ?
            '$1$2_preset/mobile/' : '$1$2_mobile/';
          _contents = _contents.replace( /(<img.+?src=.+?plaync.co.+?)(download)\//g, preset );
        }

        if ( Util.and( Config.isUserInfoWithServer, Config.serverName, _gameUser, _gameUser.gameServerId ) ) {
          _server = `<span class="server">${ Util.or( Config.serverName[_gameUser.gameServerId], '' ) }</span>`;
        }

        if ( !Config.isMyProfile ) {
          //dosen't show my Profile Info
          userProfile = `${ Util.or( _gameUser.gameCharacterName, _loginUser.name ) }${ _server }${raceName}`;
        } else {
          userProfile = `<a href="${ GameInfo.userProfile( _loginUser.uid, Config.guid, _gameUser.gameCharacterName, _gameUser.gameServerId ) }">
            ${ Util.or( _gameUser.gameCharacterName, _loginUser.name ) }</a>${ _server }${raceName}`;
        }

        if ( Util.and( _gameUser.gameCharacterName, ( Util.or( _gameUser.gameCharacterId, _gameUser.gameUserUid ) ) ) ) {
          //character
          if ( !Config.isMyProfile ) {
            userProfile = `${ _gameUser.gameCharacterName }${ _server }${raceName}`;
          } else {
           userProfile = `<a href="${ GameInfo.gameUserProfile( _gameUser.gameUserUid, _loginUser.uid, Config.guid,
             _gameUser.gameCharacterName, _gameUser.gameServerId,  _gameUser.gameCharacterId ) }">${ _gameUser.gameCharacterName }</a>${ _server }${raceName}`;
          }
        }

        if ( Config.writerInfo ) {
          //bns library
          const _writerContents = _article[ Config.writerInfo ].contents;
          userProfile = ( _writerContents ) ? '글: ' + _writerContents.writing : Util.or( _writer.loginUser.name, _writer.gameUser.gameCharacterName );
          userProfile = ( Util.and( _writerContents, _writerContents.picture ) ) ? `${ userProfile } / 그림: ${ _writerContents.picture }` : userProfile;
          userProfile = ( Util.and( _writerContents, _writerContents.illustrator ) ) ? `${ userProfile } / 일러스트: ${ _writerContents.illustrator }` : userProfile;
        }

        //ncAccount
        if ( !userProfile ) {
          userProfile = _loginUser.name;
        }

        if ( Util.and( _communityLevelName, _communityLevelName !== '-' ) ) {
          communityLevelName = _Template.communityLevelName( _communityLevelName );
        }

        let userButtons = '';
        let utilButtons = '';
        let likeButton = '';
        let bookmarkButton = '';
        let reportButton = '';
        let writeButton = '';

        if ( !Config.isAdmin ) {
          userButtons = `<li class="more-items"><button class="co-btn co-btn-modify">${Config.L10N.more_modify}</button></li>
          <li clss="more-items"><button class="co-btn co-btn-delete">${Config.L10N.more_delete}</button></li>`;
        }

        if ( !isNotice ) {
          likeButton = `<button class="co-btn co-btn-like">
          <i class="fe-icon-vote-like"></i><span>${Config.L10N.recommend}</span><em>${( _article.goodCount >= 0 ) ? numberWithCommas(_article.goodCount) : 0}</em>
          </button>`;
        }

        if ( Util.and( !isMyArticle, Config.isBookmark ) ) {
          bookmarkButton = `<button class="co-btn co-btn-bookmark${ ( _v.isScrapArticle ) ? ` is-active` : `` }">
          <i class="fe-icon-bookmark"></i><span>${ Config.L10N.more_bookmark }</span>
          </button>`;
        }

        if ( Util.and( !isMyArticle, !_adminUser ) ) {
          reportButton = `<button class="co-btn co-btn-report">${ Config.L10N.more_report }</button>`;
        }

        if ( Util.and( !Config.isAdmin, !_adminUser ) ) {
          utilButtons = `<div class="wrap-util">
          <button class="co-btn co-btn-modify">${ Config.L10N.more_modify }</button>
          <button class="co-btn co-btn-delete">${ Config.L10N.more_delete }</button>
          ${ reportButton }
          </div>`;
        }

        if ( Config.isWrite ) {
          writeButton = `<button class="co-btn co-btn-round co-btn-write"><i class="fe-icon-write_w"></i><span>${ Config.L10N.btn_write }</span></button>`;
        }

        return `<section class="board-view">
        <div class="view-header" style="${ ( Config.isHideViewInfo ) ? `display:none;` : ``}">
        <h2 class="view-title">${ _article.title }</h2>
        <div class="view-info">
        <span class="writer">
        ${ communityLevelName }
        ${( Util.and( _adminUser, _writer.emoticonUrl ) ) ?
        `<img src="${ _writer.emoticonUrl }" alt=""/>` :
        `${ userProfile }`
        }
        </span>

        ${ ( !isNaN( _article.postDate ) ) ?
        `<span class="date">${ dateFormat._format( new Date( _article.postDate ) ) }</span>` :
        `<span class="date">${ dateFormat.printFull( _article.postDate ) }</span>`
        }

        <span class="hit" data-count="${_article.hitCount}">${ Config.L10N.hit }<em>${ numberWithCommas(_article.hitCount) }</em></span>
        ${( _article.commentCount ) ?
        `<span class="comment" data-count="${_article.commentCount}">${ Config.L10N.comment }<em>${ numberWithCommas(_article.commentCount) }</em></span>` :
        ``
        }
        </div>
        </div>
        <div class="view-body">
        ${ Util.escape( _contents ) }
        <!--contents-->
        </div>
        <div class="view-utils">
        ${ likeButton }
        ${ bookmarkButton }
        ${( Config.isShare ) ?
        `<div id="ncShare" class="nc-share"></div>` : ''}
        </div>
        ${ ( Util.or( Config.isAdmin, _adminUser, !Config.isShowSignature ) ) ? `` : ( Config.isBnsApp ) ? _Template.viewSignatureApp( _data ) : _Template.viewSignature( _data ) }
        <div class="view-bottom" style="${ ( Config.isHideViewInfo ) ? `display:none;` : ``}">
        <div class="left">${ ( !Config.isShowBtnList ) ?
          `` : `<button class="co-btn co-btn-round co-btn-list"><i class="fe-icon-back"></i><span>${ Config.L10N.btn_list }</span></button>`}
        </div>
        <div class="right">
        ${ utilButtons }
        ${ writeButton }
        </div>
        </div>
        </section>`;
      },
    });
  },

  vote: ( data, goodCount ) => {
    return `<div>
    <span>${Config.L10N.recommend}</span>
    <button id="voteButton">${Config.L10N.recommend}</button>
    <span>${( data && data.voteType === 'FOR' ) ? `${Config.L10N.recommend}` : ''}</span>
    <span id="goodCount">${( goodCount && goodCount >= 0 ) ? `${goodCount}` : 0 }</span>
    </div>`;
  },

  scrapInfo: ( scrapCount, templateId ) => {
    return Template.render({
      data: scrapCount,
      template: ( _v ) => `
      <span>스크랩</span><span id="${templateId}">${_v}</span>`,
    });
  },

  scrapButton: ( scrapCount, templateId ) => {
    return `<button id=${templateId}>${Config.L10N.more_bookmark} ${scrapCount}</button>`;
  },

  scrapDeleteButton: ( templateId ) => {
    return `<button id=${templateId}>${Config.L10N.more_bookmark} ${Config.L10N.more_delete}</button>`;
  },

  modal: ( _id = 'ncCommunityReportModal' ) => {
    return `<div id="${_id}" class="co-layer-modal"></div>`;
  },

  report: ( _id = 'ncCommunityReport', commentPrefix = '' ) => {
    return `
      <div id="${_id}" class="co-layer nc-community-report">
      <header class="co-layer-header">
      <h1 class="co-layer-title">${Config.L10N.report_title}</h1>
      <button class="co-btn co-btn-close ly-close"><i class="fe-icon-close"></i></button>
      </header>

      <section class="co-layer-contents report-contents">
      <div class="report-remain">
      <h2>
      ${Config.L10N.report_remain}
      <span class="wrap-count"><em class="count">16</em>${Config.L10N.report_number}</span>
      </h2>
      <p class="desc">${Config.L10N.report_info}</p>
      </div>

      <div class="report-target">
      <h2>${Config.L10N.report_username}</h2>
      <strong class="target"></strong>
      </div>

      <div class="report-cause">
      <h2>${Config.L10N.report_reason}</h2>
      <ul class="list-cause" id="${commentPrefix}reportCauseList">
      <li>
      <label for="${commentPrefix}reportCase1">${Config.L10N.report_reason1}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase1" checked="checked" value="1"/>
      <i class="fe-icon-checked"></i>
      </li>
      <li>
      <label for="${commentPrefix}reportCase2">${Config.L10N.report_reason2}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase2" value="2"/>
      <i class="fe-icon-checked"></i>
      </li>
      <li>
      <label for="${commentPrefix}reportCase3">${Config.L10N.report_reason3}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase3" value="3" />
      <i class="fe-icon-checked"></i>
      </li>
      <li>
      <label for="${commentPrefix}reportCase4">${Config.L10N.report_reason4}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase4" value="4" />
      <i class="fe-icon-checked"></i>
      </li>
      <li>
      <label for="${commentPrefix}reportCase5">${Config.L10N.report_reason5}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase5" value="5" />
      <i class="fe-icon-checked"></i>
      </li>
      <li>
      <label for="${commentPrefix}reportCase6">${Config.L10N.report_reason6}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase6" value="6" />
      <i class="fe-icon-checked"></i>
      </li>
      <li>
      <label for="${commentPrefix}reportCase7">${Config.L10N.report_reason7}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase7" value="7" />
      <i class="fe-icon-checked"></i>
      </li>
      <li>
      <label for="${commentPrefix}reportCase8">${Config.L10N.report_reason8}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase8" value="8" />
      <i class="fe-icon-checked"></i>
      </li>
      <li>
      <label for="${commentPrefix}reportCase9">${Config.L10N.report_reason9}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase9" value="9" />
      <i class="fe-icon-checked"></i>
      </li>
      <li>
      <label for="${commentPrefix}reportCase0">${Config.L10N.report_reason0}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase0" value="0" />
      <i class="fe-icon-checked"></i>
      </li>
      </ul>
      </div>
      </section>

      <footer class="co-btn-wrap report-btn-wrap">
      <button class="reportFinish co-btn co-btn-finish">${Config.L10N.btn_finish}</button>
      <button class="reportCancel co-btn co-btn-cancel ly-close">${Config.L10N.btn_cancel}</button>
      </footer>
      </div>`;
  },

  listMsg: ( data ) => {
    return `<div class="board-list-none"><p>${Config.L10N.list_none_article}</p></div>`;
  },

  empty: ( _id, _list ) => {
    return Template.render({
      data: _list,
      template: ( list ) => `<ul class="${_id} board-list-none"><li>${_list}</li></ul>`,
    });
  },

  emptySearch: ( _id, _list, param = '' ) => {
    return Template.render({
      data: _list,
      template: ( list ) => `<ul class="${_id} board-list-none">
        <li>${_list}<div class="co-btn-wrap"><a href="${Config.listPage}?${param}" class="co-btn co-btn-round co-btn-list">${Config.L10N.btn_fromlist}</a>
        </div></li></ul>`,
    });
  },
};

export default _Template;
